/* eslint-disable global-require */
import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'

import LocaleProvider from 'antd/lib/locale-provider'
import zhCN from 'antd/lib/locale-provider/zh_CN'
import 'moment/locale/zh-cn'

import App from './app'
import './styles/index.less'

if (process.env.NODE_ENV === 'development') {
    // mock data
    // require('@/mock/index')
}

ReactDOM.render(
    <LocaleProvider locale={zhCN}>
        <App />
    </LocaleProvider>,
    document.getElementById('root')
)
